var cov_27yxt7x5sv = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Button/styles/index.ts",
      hash = "f38a7df208fb0bc564feb9d1537883ec6122d72a",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Button/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 27
        },
        end: {
          line: 5,
          column: 59
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var buttonLess = {};
import genaration from '../../utils/classname';
export var buttonClass = (cov_27yxt7x5sv.s[0]++, genaration(buttonLess, 'button'));